<div [id]="id" class="status-filters">
    <div #filterByStatus class="overlay-content">
        <p-button
            [id]="id + '-select-status-btn'"
            class="select-status-btn"
            icon="fa-regular fa-chevron-down"
            iconPos="right"
            [label]="statusTextDisplay | translate: { number: selectedStatusesArr.length }"
            [styleClass]="
                selectedStatusesArr[0] !== statusesToDisplay[0].value
                    ? 'selected-status-button'
                    : 'selected-default-status-btn'
            "
            (click)="statusesPanel.toggle($event)"></p-button>

        <p-overlayPanel
            #statusesPanel
            [appendTo]="filterByStatus"
            [ariaLabel]="'primers.samples.statusesMultiselect.ariaLabel' | translate">
            <ng-template pTemplate>
                @for (item of statusesToDisplay; track item) {
                    <div class="filter-selection">
                        <p-checkbox
                            [ngModel]="selectedStatusesArr"
                            [value]="item.value"
                            [inputId]="item.value.toString()"
                            [label]="item.text | translate"
                            (onChange)="onStatusSelect(item.value)"
                            [ngClass]="{ 'selected-checkbox': selectedStatusesArr.includes(item.value) }"></p-checkbox>
                    </div>
                }
            </ng-template>
        </p-overlayPanel>
    </div>
</div>
